import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiX, FiCopy, FiCheck, FiMail, FiMessageSquare } = FiIcons;

const TemplatePreviewModal = ({ isOpen, onClose, template, property }) => {
  const [copied, setCopied] = React.useState(false);

  if (!isOpen || !template) return null;

  const injectVariables = (text) => {
    if (!text || !property) return text;
    const replacements = {
      '[Tenant Name]': property.tenantName || 'Tenant',
      '[Property Name]': property.name,
      '[Lease End Date]': property.leaseEnd || 'TBD',
      '[Move-In Date]': property.leaseStart || 'TBD',
      '[Rent Rate]': property.rentRate || '0',
      '[Lock Code]': property.lockCode || 'XXXX#',
      '[Date]': new Date().toLocaleDateString()
    };
    let result = text;
    Object.entries(replacements).forEach(([key, value]) => {
      result = result.replace(new RegExp(key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), value);
    });
    return result;
  };

  const finalSubject = injectVariables(template.subject);
  const finalContent = injectVariables(template.content);

  const handleCopy = () => {
    navigator.clipboard.writeText(finalContent);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[70] p-4">
      <div className="bg-white rounded-3xl shadow-2xl w-full max-w-lg overflow-hidden animate-in zoom-in duration-200">
        <div className="p-6 border-b border-gray-100 flex justify-between items-center bg-gray-50/50">
          <div>
            <h2 className="text-xl font-black text-gray-900">Message Preview</h2>
            <p className="text-[10px] font-black text-indigo-600 uppercase tracking-widest mt-1">
              Personalized for {property?.name || 'Selected Property'}
            </p>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <SafeIcon icon={FiX} size={24} />
          </button>
        </div>

        <div className="p-8 space-y-6">
          <div className="space-y-4">
            <div className="p-4 bg-gray-50 rounded-2xl border border-gray-100">
              <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-1">Subject Line</p>
              <p className="font-bold text-gray-900">{finalSubject}</p>
            </div>
            <div className="p-6 bg-white border border-gray-200 rounded-2xl shadow-inner min-h-[200px]">
              <p className="text-sm text-gray-700 font-medium whitespace-pre-wrap leading-relaxed">
                {finalContent}
              </p>
            </div>
          </div>

          <div className="flex gap-3">
            <button 
              onClick={handleCopy}
              className="flex-1 py-4 bg-gray-900 text-white font-black rounded-2xl flex items-center justify-center gap-2 hover:bg-black transition shadow-lg"
            >
              <SafeIcon icon={copied ? FiCheck : FiCopy} />
              {copied ? 'Copied to Clipboard' : 'Copy Content'}
            </button>
            <button 
              className="flex-1 py-4 bg-indigo-600 text-white font-black rounded-2xl flex items-center justify-center gap-2 hover:bg-indigo-700 transition shadow-lg shadow-indigo-100"
            >
              <SafeIcon icon={FiMail} />
              Send Email
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplatePreviewModal;